import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarPlus, Copy, MessageSquare } from "lucide-react";
import api, { API } from "../lib/api";
import { Button } from "./ui/button";

export default function CalendarCard() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get("/admin/calendar-link").then(({ data }) => setInfo(data)).catch(() => {});
  }, []);

  const feedUrl = info ? `${API}/calendar/${info.token}/bookings.ics` : "";
  const googleUrl = feedUrl ? `https://calendar.google.com/calendar/r?cid=${encodeURIComponent(feedUrl.replace(/^https?:/, "webcal:"))}` : "";

  const copy = async () => {
    await navigator.clipboard.writeText(feedUrl);
    toast.success("Calendar link copied.");
  };

  return (
    <div className="grid md:grid-cols-2 gap-5" data-testid="calendar-card">
      <div className="glass-card rounded-sm p-7">
        <CalendarPlus className="w-5 h-5 text-[#FF2079] mb-4" />
        <div className="font-display text-2xl text-white mb-2">Google Calendar</div>
        <p className="text-sm text-[#A09CA3] leading-relaxed mb-5">
          Add this link to Google Calendar once. Every booking (except cancelled) will appear on your phone. Google refreshes it every few hours.
        </p>
        <div data-testid="calendar-feed-url" className="text-xs text-[#FFB6C1] break-all bg-[#141414] border border-white/10 rounded-sm p-3 mb-4">
          {feedUrl || "Loading…"}
        </div>
        <div className="flex flex-wrap gap-3">
          <Button asChild data-testid="add-to-google-btn" className="pink-glow-btn bg-[#FF2079] hover:bg-[#D91666] text-white rounded-sm h-10 px-5 text-[10px] tracking-[0.28em] uppercase">
            <a href={googleUrl} target="_blank" rel="noreferrer">Add to Google Calendar</a>
          </Button>
          <Button data-testid="copy-calendar-btn" onClick={copy} variant="outline" className="bg-transparent border-white/10 text-white hover:bg-white/5 rounded-sm h-10 px-5 text-[10px] tracking-[0.28em] uppercase">
            <Copy className="w-3.5 h-3.5 mr-1.5" /> Copy Link
          </Button>
        </div>
      </div>
      <div className="glass-card rounded-sm p-7">
        <MessageSquare className="w-5 h-5 text-[#FF2079] mb-4" />
        <div className="font-display text-2xl text-white mb-2">Booking Text Alerts</div>
        <p className="text-sm text-[#A09CA3] leading-relaxed mb-5">
          When someone books, you get a text and the client gets a confirmation text.
        </p>
        <div data-testid="sms-status" className={`inline-flex text-[10px] tracking-[0.28em] uppercase px-3 py-2 rounded-sm border ${info?.sms_enabled ? "text-emerald-400 border-emerald-400/30" : "text-[#FFB6C1] border-[#FFB6C1]/30"}`}>
          {info?.sms_enabled ? "Active" : "Waiting for Twilio account"}
        </div>
      </div>
    </div>
  );
}
